import type { CardButtonProps } from '@jouzen/ecom-components/v3/CardButton';

import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

const commonButtonProps: CardButtonProps = {
  ariaLabel: 'press_read_article',
  external: true,
  className: 'bg-mustard-350  text-sandstone-200',
  rel: 'noopener noreferrer',
  target: '_blank',
};

export const metabolicHealthArticleCards = (
  localePartialUrl: string,
): ArticleCardDataProps[] => [
  {
    heading: 'metabolic_health_blog_article_poor_sleep',
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog${localePartialUrl}sleep-and-metabolic-health/`,
    },
  },
  {
    heading: 'metabolic_health_blog_article_biosensor',
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog${localePartialUrl}how-stelo-glucose-biosensor-works/`,
    },
  },
  {
    heading: 'metabolic_health_blog_article_stabilize',
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog${localePartialUrl}benefits-of-stabilizing-blood-sugar/`,
    },
  },
];

export const metabolicHealthArticleImageData = (
  localePartialUrl: string,
): ArticleImageProps => ({
  alt: 'ring_food_alt',
  buttonProps: {
    className: 'text-sandstone-500',
    external: true,
    href: `https://ouraring.com/blog${localePartialUrl}what-is-metabolic-health/`,
    label: 'read_more',
    rel: 'noopener noreferrer',
    target: '_blank',
    variant: 'secondary-light',
  },
  heading: 'metabolic_health_blog_hero',
  src: 'featured_article_metabolic_health.jpg',
  headingClassname: 'max-w-80',
});
